import React, { createContext, useContext } from 'react';
import { countriesEnglish } from '../constants/countries';

const CustomerContext = createContext();

export function CustomerContextProvider({
    analyticsFunctions,
    children,
    countries,
    defaultCountryCode,
    idTypes,
    logo,
    states,
}) {
    return (
        <CustomerContext.Provider
            value={{
                analyticsFunctions: analyticsFunctions || {
                    logPageViewEvent: () => {},
                    logUserAction: () => {},
                    logError: () => {},
                    logLanguageChange: () => {},
                    getPassengerAttributes: () => {},
                    getClaimAttributes: () => {},
                    getSelectedBags: () => {},
                },
                countries: countries || countriesEnglish,
                defaultCountryCode: defaultCountryCode || '',
                idTypes: idTypes || undefined,
                logo,
                states: states || undefined,
            }}
        >
            {children}
        </CustomerContext.Provider>
    );
}

export function useCustomerContext() {
    const context = useContext(CustomerContext);

    if (!context) {
        throw new Error(
            'useCustomerContext must be used within a CustomerContextProvider. Wrap a parent component in <CustomerContextProvider to fix this error'
        );
    }

    return context;
}
